import { render, staticRenderFns } from "./GameOverScreen.vue?vue&type=template&id=112cfa62&scoped=true"
import script from "./GameOverScreen.vue?vue&type=script&lang=js"
export * from "./GameOverScreen.vue?vue&type=script&lang=js"
import style0 from "./GameOverScreen.vue?vue&type=style&index=0&id=112cfa62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112cfa62",
  null
  
)

export default component.exports